import { InputAdornment, TextField, makeStyles } from '@material-ui/core';
import { colors } from 'design-system';
import React from 'react';
import { SearchIcon } from 'src/components/Icons';

const useStyles = makeStyles({
  searchBar: {
    padding: 30,
    paddingTop: 20,
    paddingBottom: 12,
    position: 'sticky',
    top: 0,
    backgroundColor: colors.white,
    zIndex: 1,
  },
  inputText: {
    color: colors.madison,
    marginBottom: 6,
  },
  inputUnderline: {
    '&:after': {
      borderBottom: `2px solid ${colors.light_silver}`,
    },
    '&:hover:not(.Mui-disabled):before': {
      borderBottom: `2px solid ${colors.light_silver}`,
    },
    '&:before': {
      borderBottom: `1px solid ${colors.light_silver}`,
    },
  },
  searchIcon: {
    marginBottom: 12,
  },
});

export type Props = {
  id: string;
  search: string;
  setSearch: (term: string) => void;
  placeholder?: string;
  customIcon?: React.ReactNode;
};

const SearchBar = React.forwardRef(
  (
    {
      id,
      search,
      setSearch,
      placeholder = 'Buscar',
      customIcon = (
        <SearchIcon color={colors.bright_turquoise} width={22} height={22} />
      ),
    }: Props,
    ref,
  ) => {
    const classes = useStyles();

    return (
      <TextField
        inputRef={ref}
        id={id}
        placeholder={placeholder}
        name="text-field-search-bar"
        defaultValue={search}
        onChange={(newValue: React.ChangeEvent<{ value: string }>) =>
          setSearch(newValue.target.value)
        }
        InputProps={{
          startAdornment: (
            <InputAdornment position="start" className={classes.searchIcon}>
              {customIcon}
            </InputAdornment>
          ),
          classes: {
            input: classes.inputText,
            underline: classes.inputUnderline,
          },
        }}
        classes={{
          root: classes.searchBar,
        }}
        fullWidth
        onClickCapture={(e) => {
          e.stopPropagation();
          e.preventDefault();
        }}
        onKeyDown={(e) => e.stopPropagation()}
      />
    );
  },
);

export default SearchBar;
